import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { GoogleOAuthProvider } from "@react-oauth/google";
// ✅ Import Redux Store
// ✅ Import React Query Client
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { CurrencyProvider } from "./context/CurrencyContext";

// ✅ Create a QueryClient instance
const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId="83025144337-262slchrg6t911houqu76mn9n55idrhd.apps.googleusercontent.com">
      <QueryClientProvider client={queryClient}>
        <CurrencyProvider>
          <App />
        </CurrencyProvider>
      </QueryClientProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);
